module.exports = require("@git-stack/hemera-plugin");